<template>

  <div class="parent">
    <div class="move">
      <h3 style="color: transparent">a</h3>
      <transition name="cube-animation1">
        <div class="cube1" v-if="cube1" :class="{'cube1': cube1}"></div>
      </transition>
      <transition name="cube-animation2">
        <div class="cube2" v-if="cube2" :class="{'cube2': cube2}">
          <admun class="admun" v-if="admunComponent"></admun>

        </div>
      </transition>
      <transition name="leaveCube">
        <div class="leaveCube2" v-if="leaveCube2" :class="{'leaveCube2': leaveCube2}"></div>
      </transition>
      <transition name="boxleave-2">
        <div class="leavebox" v-if="leavebox" :class="{'leavebox': leavebox}">

        </div>
      </transition>
      <div class="hide-mobile">
        <video class="witheBox1" id="MyVideo" v-if="whiteBox1" ref="videoPlayer" @mouseenter="showRandomVideo"
               @mouseout="showDefaultVideo" autoplay muted>
          <source :src="currentVideo.defaultvid" type="video/webm">
          <source :src="currentVideo.defaultvid" type="video/mp4">

        </video>

        <div class="witheBox2 " id="myImages" v-if="whiteBox2" @mouseenter="showRandomVideo"
             @mouseout="showDefaultVideo">
          <img :src="cubeMovable.img" alt="0">


        </div>


      </div>
      <div class="show-mobile">
        <video class="witheBox1" id="MyVideo2" v-if="whiteBox1" ref="videoPlayer" @touchstart="startTouchVideo" autoplay
               playsinline muted>
          <source :src="currentVideo.defaultvid" type="video/webm">
          <source :src="currentVideo.defaultvid" type="video/mp4">

        </video>

        <div class="witheBox3 " id="myImages2" v-if="whiteBox3">
          <img :src="cubeMovable.img" alt="0">


        </div>
      </div>
    </div>

    <transition name="cube-movable-1" >
      <div class="total1">

        <div id="movable1" class="movable1" v-if="movable1" :class="{'movable1':movable1}" @touchstart.prevent>
          <div class="divition" v-if="divition"></div>
          <p class="about" v-if="about" :class="{'about':about}"><span class="orginal-text1">ABOUT</span>
            <br>
            <span class="replacement-text1">OUR STORY</span>
          </p>
          <div class="divition-hover" v-if="movable1"></div>
        </div>

      </div>


    </transition>

    <transition name="cube-movable-2">
      <div class="total2">
        <div class="movable2" v-if="movable2" :class="{'movable2':movable2}" @touchstart.prevent>
          <div class="divition2" v-if="divition2"></div>
          <p class="awards" v-if="awards" :class="{'awards':awards}"><span class="orginal-text2">AWARDS</span>
            <br>
            <span class="replacement-text2">RECOGNITION</span>
          </p>

          <div class="divition-hover" v-if="movable2"></div>

        </div>

      </div>
    </transition>

    <transition name="cube-movable-3">
      <div class="total3" @touchstart.prevent  @touchend.prevent @touchmove.prevent>
        <div v-if="movable3" :class="{'movable3':movable3}" @touchstart.prevent  @touchend.prevent @touchmove.prevent>
          <div class="divition3" v-if="divition3" ></div>
          <p class="soon" v-if="soon" :class="{'soon':soon}" ><span class="orginal-text3">COMING SOON </span>

            <br>
            <span class="replacement-text3" >EVOLVING</span>
          </p>

          <div class="divition-hover" v-if="movable3" ></div>
        </div>

      </div>

    </transition>

    <transition name="cube-movable-4">
      <div class="total4">
        <div class="movable4" v-if="movable4" :class="{'movable4':movable4}" @touchstart.prevent>
          <div class="divition4" v-if="divition4"></div>
          <p class="design" v-if="design" :class="{'design':design}"><span class="orginal-text4">DESIGN</span>

            <br>
            <span class="replacement-text4">VISION</span>
          </p>

          <div class="divition-hover" v-if="movable4"></div>
        </div>
      </div>


    </transition>

    <transition name="cube-movable-5">
      <div class="total5">
        <div class="movable5" v-if="movable5" :class="{'movable5':movable5}" @touchstart.prevent>
          <div class="divition5" v-if="divition5"></div>
          <p class="construction" v-if="construction" :class="{'construction':construction}"><span
              class="orginal-text5">CONSTRUCTION</span>
            <br>
            <span class="replacement-text5">TRANSFORMATION</span>
          </p>

          <div class="divition-hover" v-if="movable5"></div>
        </div>
      </div>


    </transition>
    <div class="circle-replace" v-if="circle" :class="{'circle-replace':circle}" @click="showElements"
         @mouseleave="hideElements">

    </div>

    <div class="circle" v-if="circle" :class="{'circle':circle}" @click="showElements"
         @mouseleave="hideElements">

      <transition name="circle-move">
        <div v-if="show">
          <div v-show="show" class="circle1"><i class="fa fa-linkedin white"></i></div>
          <div v-show="show" class="circle2"><i class="fa fa-youtube-play white mt-2"></i></div>
          <div v-show="show" class="circle3"><i class="fa fa-instagram white mt-2"></i></div>
        </div>

      </transition>
    </div>
    <!--    &lt;!&ndash;          <div class="circle4"><i class="fa fa-facebook-f white mt-2"></i></div>&ndash;&gt;-->
    <!--    &lt;!&ndash;          <div class="circle5"><i class="fa fa-telegram white mt-2"></i></div>&ndash;&gt;-->


  </div>


</template>

<script>

import textAdmun from './text-admun-animation.vue'
import 'animate.css';

export default {

  components: {
    admun: textAdmun,
  },
  name: "cube-animation",
  data() {
    return {


      cube1: false,
      cube2: false,
      leaveCube2: false,
      leavebox: false,
      admunComponent: false,
      whiteBox1: false,
      whiteBox2: false,
      whiteBox3: false,
      movable1: false,
      movable2: false,
      movable3: false,
      movable4: false,
      movable5: false,
      divition: false,
      divition2: false,
      divition3: false,
      divition4: false,
      divition5: false,
      about: false,
      awards: false,
      soon: false,
      design: false,
      construction: false,
      circle: false,
      show: false,
      showVido: true,
      timeoutId: null,
      deviceType: null,
      condition: false,

      currentVideo: {
        defaultvid: require('../../public/videos/Main.mp4'),
      },
      cubeMovable: {
        img: require('../../public/image/00.jpg'),
      },

      videos: [
        'N01.mp4',
        'N02.mp4',
        'N03.mp4',
        'N04.mp4',
        'N05.mp4',
        'N06.mp4',
        'N07.mp4'

      ],
      currentIndex: 0

    }

  },
  mounted() {


    this.setDeviceType();
    setTimeout(() => {
      this.cube1 = true;
      setTimeout(() => {
        this.cube1 = false;
      }, 2000)
      setTimeout(() => {


        this.cube2 = true;

        setTimeout(() => {
          this.admunComponent = true;
          setTimeout(() => {
            this.cube2 = false;
            this.leaveCube2 = true;

            setTimeout(() => {
              this.admunComponent = false;
            }, 4000)
            setTimeout(() => {
              this.whiteBox1 = true;
              setTimeout(() => {
                this.whiteBox2 = true;
              }, 100)
              setTimeout(() => {
                this.whiteBox3 = true;
              }, 500)
            }, 2000)


            setTimeout(() => {
              this.movable1 = true;
              this.movable2 = true;
              this.movable3 = true;
              this.movable4 = true;
              this.movable5 = true;
              setTimeout(() => {
                this.divition = true;
                this.divition2 = true;
                this.divition3 = true;
                this.divition4 = true;
                this.divition5 = true;
                setTimeout(() => {
                  this.about = true;
                  this.awards = true;
                  this.soon = true;
                  this.design = true;
                  this.construction = true;

                  setTimeout(() => {
                    this.circle = true;

                  }, 1000)
                },)
              }, 500)


            }, 3600);


          }, 7000)


        }, 1000)
      }, 1500)
    }, 1000);


  },
  beforeUnmount() {
    this.currentVideo.defaultvid = require('../../public/videos/Main.mp4');

  },
  methods: {


    showElements() {
      this.show = !this.show;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.show = false;
      }, 7000)
    },


    startTouchVideo() {


      this.currentIndex = Math.floor(Math.random() * this.videos.length);

      console.log(this.currentIndex);
      document.getElementById("MyVideo2").src = '/videos/' + this.videos[this.currentIndex];
      if (this.currentIndex) {
        this.cubeMovable.img = require('../../public/image/00.jpg');


      }

      setTimeout(() => {

        this.currentIndex = (this.currentIndex) % this.videos.length;

        if (this.currentIndex === 0) {
          this.cubeMovable.img = require('../../public/image/01.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo2").src = require('../../public/videos/R01.mp4');


          }, 500)


          setTimeout(() => {

            this.cubeMovable.img = require('../../public/image/00.jpg');

          }, 1000)


        } else if (this.currentIndex === 1) {
          this.cubeMovable.img = require('../../public/image/02.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo2").src = require('../../public/videos/R02.mp4');

          }, 500)


          setTimeout(() => {

            this.cubeMovable.img = require('../../public/image/00.jpg');

          }, 1000)


        } else if (this.currentIndex === 2) {
          this.cubeMovable.img = require('../../public/image/03.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo2").src = require('../../public/videos/R03.mp4');


          }, 500)

          setTimeout(() => {

            this.cubeMovable.img = require('../../public/image/00.jpg');

          }, 1000)


        } else if (this.currentIndex === 3) {
          this.cubeMovable.img = require('../../public/image/04.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo2").src = require('../../public/videos/R04.mp4');

          }, 500)
          setTimeout(() => {

            this.cubeMovable.img = require('../../public/image/00.jpg');
          }, 1000)

        } else if (this.currentIndex === 4) {


          this.cubeMovable.img = require('../../public/image/05.jpg');


          setTimeout(() => {
            document.getElementById("MyVideo2").src = require('../../public/videos/R05.mp4');

          }, 500)


          setTimeout(() => {
            this.cubeMovable.img = require('../../public/image/00.jpg');
          }, 1000)


        } else if (this.currentIndex === 5) {
          this.cubeMovable.img = require('../../public/image/06.jpg');


          setTimeout(() => {
            document.getElementById("MyVideo2").src = require('../../public/videos/R06.mp4');


          }, 500)


          setTimeout(() => {
            this.cubeMovable.img = require('../../public/image/00.jpg');
          }, 1000)


        } else if (this.currentIndex === 6) {
          this.cubeMovable.img = require('../../public/image/07.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo2").src = require('../../public/videos/R07.mp4');


          }, 500)


          setTimeout(() => {
            this.cubeMovable.img = require('../../public/image/00.jpg');
          }, 1000)
        }
      }, 500)


    },


    showRandomVideo: function () {


      this.currentIndex = Math.floor(Math.random() * this.videos.length);

      console.log(this.currentIndex);
      document.getElementById("MyVideo").src = '/videos/' + this.videos[this.currentIndex];
      if (this.currentIndex) {
        this.cubeMovable.img = require('../../public/image/00.jpg');

      }

      // this.currentVideo.defaultvid = '/videos/' + this.videos[randomIndex];
    },
    showDefaultVideo() {

      // this.currentIndex = Math.floor(Math.random() * this.videos.length);


      setTimeout(() => {

        this.currentIndex = (this.currentIndex) % this.videos.length;

        if (this.currentIndex === 0) {
          this.cubeMovable.img = require('../../public/image/01.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo").src = require('../../public/videos/R01.mp4');


          }, 500)


          setTimeout(() => {

            this.cubeMovable.img = require('../../public/image/00.jpg');

          }, 1000)


        } else if (this.currentIndex === 1) {
          this.cubeMovable.img = require('../../public/image/02.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo").src = require('../../public/videos/R02.mp4');

          }, 500)


          setTimeout(() => {

            this.cubeMovable.img = require('../../public/image/00.jpg');

          }, 1000)


        } else if (this.currentIndex === 2) {
          this.cubeMovable.img = require('../../public/image/03.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo").src = require('../../public/videos/R03.mp4');


          }, 500)

          setTimeout(() => {

            this.cubeMovable.img = require('../../public/image/00.jpg');

          }, 1000)


        } else if (this.currentIndex === 3) {
          this.cubeMovable.img = require('../../public/image/04.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo").src = require('../../public/videos/R04.mp4');

          }, 500)
          setTimeout(() => {

            this.cubeMovable.img = require('../../public/image/00.jpg');
          }, 1000)

        } else if (this.currentIndex === 4) {


          this.cubeMovable.img = require('../../public/image/05.jpg');


          setTimeout(() => {
            document.getElementById("MyVideo").src = require('../../public/videos/R05.mp4');

          }, 500)


          setTimeout(() => {
            this.cubeMovable.img = require('../../public/image/00.jpg');
          }, 1000)


        } else if (this.currentIndex === 5) {
          this.cubeMovable.img = require('../../public/image/06.jpg');


          setTimeout(() => {
            document.getElementById("MyVideo").src = require('../../public/videos/R06.mp4');


          }, 500)


          setTimeout(() => {
            this.cubeMovable.img = require('../../public/image/00.jpg');
          }, 1000)


        } else if (this.currentIndex === 6) {
          this.cubeMovable.img = require('../../public/image/07.jpg');

          setTimeout(() => {
            document.getElementById("MyVideo").src = require('../../public/videos/R07.mp4');


          }, 500)


          setTimeout(() => {
            this.cubeMovable.img = require('../../public/image/00.jpg');
          }, 1000)
        }
      }, 500)


      console.log(this.currentIndex);


    },

    setDeviceType() {
      const platform = navigator.platform.toLowerCase();
      if (/(android|webos|iphone|ipad|ipod|blackberry|windows phone)/.test(platform)) {
        this.deviceType = 'mobile';
      } else if (/mac|win|linux/i.test(platform)) {
        this.deviceType = 'desktop';


      } else if (/tablet|ipad/i.test(platform)) {
        this.deviceType = 'tablet';

      } else {
        this.deviceType = 'unknown';
      }


    },





  }


}
</script>


<style>
.show-mobile {
  display: none;
}

.hide-mobile {
  display: inline-block;
}

.white {
  color: black;
}

body {
  overflow-x: hidden
}

.move {
  display: flex;
  height: 100%;
  max-width: 100%;
  z-index: 0;
  justify-content: center;
  align-items: center;
  text-align: center;

}

.parent {
  position: relative;
  width: 100%;
  height: 100%;
}

.admun {
  justify-content: center;
  position: absolute;
  text-align: center;
  top: calc(50% - 95px / 2);
  left: calc(50% - 232px / 2);
  z-index: -1;
}

.cube1 {
  position: fixed;
  width: 40px;
  height: 40px;
  top: calc(50% - 40px / 2);
  left: calc(50% - 40px / 2);
  background-color: black;
  animation: openbox1 1000ms linear normal forwards !important;


  z-index: 2;


}

.cube-animation1-enter-active {
  animation-fill-mode: forwards;
}


@keyframes openbox1 {
  0% {
    opacity: 0;
    transition: 100ms ease;
  }
  35% {
    opacity: 0;
    transition: 1000ms ease;
  }

  75% {
    opacity: 1;
    transition: all 800ms ease;
    position: fixed;
    top: calc(50% - 40px / 2);
    left: calc(50% - 40px / 2);
    width: 40px;
    height: 40px
  }

  100% {
    transition: all 100ms ease;
    position: fixed;
    height: 100%;
    top: 0;
    bottom: 0;
    width: 40px;
    left: calc(50% - 40px / 2);


  }
}


.cube2 {
  position: fixed;
  height: 100%;
  top: 0;
  bottom: 0;
  width: 40px;
  left: calc(50% - 40px / 2);
  background-color: black;
  animation: openbox2 600ms linear normal forwards !important;


}

.cube-animation2-enter-active {
  animation-fill-mode: forwards;
}


@keyframes openbox2 {
  0% {

    transition: 350ms ease 100ms;
    position: fixed;
    height: 100%;
    top: 0;
    bottom: 0;
    width: 35px;
    left: calc(50% - 35px / 2);

  }
  100% {
    transition: 300ms ease;
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    height: 100%;
    top: 0;
    bottom: 0;
  }

}

.leaveCube-enter-active {
  animation-fill-mode: forwards;
}

.leaveCube2 {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  height: 100%;
  top: 0;
  bottom: 0;
  background-color: black;
  animation: leavecube2 2000ms ease normal forwards !important;
  z-index: 4;
}

@keyframes leavecube2 {

  50% {
    transition: 300ms ease;
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    height: 100%;
    top: 0;
    bottom: 0;
  }
  75% {
    transition: 100ms ease;
    position: fixed;
    height: 100%;
    top: 0;
    bottom: 0;
    width: 10px;
    left: calc(50% - 10px / 2);

  }

  85% {
    transition: 350ms ease;
    position: fixed;
    height: 100%;
    top: 0;
    bottom: 0;
    width: 40px;
    left: calc(50% - 40px / 2);
  }
  95% {

    opacity: 1;
    transition: all 350ms ease;
    position: fixed;
    top: calc(50% - 10px / 2);
    left: calc(50% - 40px / 2);
    width: 40px;
    height: 10px

  }
  100% {

    transition: all 350ms ease;
    position: fixed;
    width: 40px;
    left: calc(50% - 40px / 2);
    top: calc(50% - 40px / 2);
    height: 40px;

  }
}


.witheBox1 {
  width: 40px;
  height: 40px;
  position: fixed;
  left: calc(50% - 40px / 2);
  top: calc(50% - 40px / 2);
  z-index: 5;
}

.witheBox2 {
  width: 40px;
  height: 40px;
  position: fixed;
  left: calc(50% - 40px / 2);
  top: calc(50% - 40px / 2);
  z-index: 4;
}

.witheBox2 img {
  width: 40px;
  height: 40px;
  position: fixed;
  left: calc(50% - 40px / 2);
  top: calc(50% - 40px / 2);
  z-index: 4;
}


.witheBox3 {
  width: 40px;
  height: 40px;
  position: fixed;
  left: calc(50% - 40px / 2);
  top: calc(50% - 40px / 2);
  z-index: 4;
}

.witheBox3 img {
  width: 40px;
  height: 40px;
  position: fixed;
  left: calc(50% - 40px / 2);
  top: calc(50% - 40px / 2);
  z-index: 4;
}


.divition {
  background: #ffffff;
  position: absolute;
  width: 101px;
  height: 35px;
  top: 0;
  left: -287%;
  z-index: 2;
  pointer-events: none;
}


.replacement-text1 {
  z-index: -2;
  position: absolute;
  font: 104.15% admun;
  top: 128%;
  transform: translateX(0);
  text-wrap: nowrap;
  opacity: 0;
  pointer-events: none;

}

.orginal-text1,
.replacement-text1 {
  display: block;
  transition: all 500ms ease-in-out;
  float: left;
}

.about {
  position: absolute;
  font: 249% admun;
  width: 398px;
  height: 41px;
  overflow-y: hidden;
  top: -5px;
  left: 7px;
  transform: translateY(0);
  margin: 1px 0 0 5px;
  transition: transform 2s ease-in-out;
  animation: about 1200ms ease-in-out forwards;
  animation-delay: 1s;
  visibility: hidden;
  z-index: -2;
  white-space: nowrap;
}

.orginal-text1 {
  margin-top: 6px;
}

.about p {
  z-index: 0;
}

.movable1 {

  visibility: hidden;
  width: 35px;
  height: 35px;
  background: black;
  position: fixed;
  top: calc(50% - 35px / 2);
  left: calc(50% - 35px / 2);
  animation: movable1 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
  z-index: 3;

}

.cube-movable-1-enter-active {
  animation-fill-mode: forwards;
}

@keyframes movable1 {
  0% {
    visibility: hidden;
    background: black;
    position: absolute;
    top: calc(50% - 35px / 2);
    left: calc(50% - 35px / 2);
  }

  50% {
    visibility: visible;
    position: absolute;
    transition: all 350ms ease;
    top: calc(35.65% - 35px / 2);
    left: calc(45.8% - 35px / 2);
  }
  100% {
    visibility: visible;
    position: absolute;
    transition: all 350ms ease;
    top: calc(37.65% - 35px / 2);
    left: calc(46.8% - 35px / 2);
  }

}

@keyframes about {

  0% {

    opacity: 1;
    transform: translateX(-100px);
    visibility: visible;


  }


  50% {

    opacity: 1;
    transform: translateX(60px);
    visibility: visible;


  }


  100% {

    opacity: 1;
    transform: translateX(30px);
    visibility: visible;


  }


}


.movable1:hover {
  background: transparent;
  border: 1px solid black;
  width: 35px;
  height: 35px;
  transition: all 500ms ease;

}


.movable1:hover .about .orginal-text1 {
  transform: translateY(-100%);
  opacity: 0;
  /*transition: all 200ms ease;*/

}

.mov3-wh {
  visibility: hidden;
  width: 10px;
  height: 10px;
  background: red;
  position: fixed;
  top: calc(50% - 10px / 2);
  left: calc(50% - 10px / 2);
  animation: movable3 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
  z-index: 3;
}

.movable1:hover .about .replacement-text1 {
  transform: translateY(-108%);
  opacity: 1;
  /*transition: all 200ms ease;*/

}


.movable1:hover .divition {
  left: -380%;
}


.movable2 {

  visibility: hidden;
  width: 20px;
  height: 20px;
  background: black;
  position: fixed;
  top: calc(50% - 20px / 2);
  left: calc(50% - 20px / 2);
  animation: movable2 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
  z-index: 3;
}

.cube-movable-2-enter-active {
  animation-fill-mode: forwards;
}

.divition2 {
  background: #ffffff;
  position: absolute;
  width: 200px;
  height: 20px;
  top: 0;
  left: 100%;
  z-index: 2;
  pointer-events: none;

}

.movable2:hover .divition2 {
  left: 122%;
}

.replacement-text2 {
  z-index: -2;
  position: absolute;
  font: 102% admun;
  top: 78%;
  left: 3%;
  transform: translateX(0);
  text-wrap: nowrap;
  opacity: 0;
  pointer-events: none;

}

.orginal-text2,
.replacement-text2 {
  display: block;
  transition: all 500ms ease-in-out;
  z-index: -2;
}

.awards {
  position: absolute;
  font: 142% admun;
  margin: 2px 0 0 0;
  width: 343px;
  top: -5px;
  left: -100px;
  height: 37px;
  overflow-y: hidden;
  transform: translateY(0);
  transition: transform 2s ease-in-out;
  animation: awards 1200ms ease-in-out forwards;
  animation-delay: 1s;
  visibility: hidden;
  z-index: -2;
  white-space: nowrap;

}

.orginal-text2 {
  margin-top: 5px;
}

.awards p {
  z-index: 0;
}

@keyframes movable2 {
  0% {
    visibility: hidden;
    background: black;
    position: absolute;
    top: calc(50% - 20px / 2);
    left: calc(50% - 20px / 2);
  }
  50% {
    visibility: visible;
    position: absolute;
    transition: all 350ms ease;

    top: calc(42.8% - 20px / 2);
    left: calc(44.2% - 20px / 2);
  }
  100% {
    visibility: visible;
    position: absolute;
    transition: all 350ms ease;
    top: calc(43.8% - 20px / 2);
    left: calc(45.2% - 20px / 2);

  }
}

@keyframes awards {

  0% {

    opacity: 1;
    transform: translateX(-15px);
    visibility: visible;

  }

  50% {

    opacity: 1;
    transform: translateX(-170px);
    visibility: visible;


  }

  100% {

    opacity: 1;
    transform: translateX(-150px);
    visibility: visible;


  }


}

.movable2:hover {
  background: transparent;
  border: 1px solid black;
  width: 20px;
  height: 20px;
  transition: all 500ms ease;

}


.movable2:hover .awards .orginal-text2 {
  transform: translateY(-120%);
  opacity: 0;
  /*transition: all 200ms ease;*/

}

.movable2:hover .awards .replacement-text2 {
  transform: translateY(-100%);
  opacity: 1;
  /*transition: all 200ms ease;*/

}


.movable3 {

  visibility: hidden;
  width: 10px;
  height: 10px;
  background: black;
  position: fixed;
  top: calc(50% - 10px / 2);
  left: calc(50% - 10px / 2);
  animation: movable3 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
  z-index: 3;
}

.movable3:hover .divition3 {
  left: -2814%;
}

.movable3:hover {
  background: transparent;
  border: 1px solid black;
  width: 10px;
  height: 10px;
  transition: all 500ms ease;

}

.movable3:hover .soon .orginal-text3 {
  transform: translateY(-110%);
  opacity: 0;
  /*transition: all 200ms ease;*/

}

.movable3:hover .soon .replacement-text3 {
  transform: translateY(-125%);
  opacity: 1;
  /*transition: all 200ms ease;*/

}

.divition3 {
  background: #ffffff;
  position: absolute;
  width: 250px;
  height: 11px;
  top: 0;
  left: -2499%;
  z-index: 2;
  pointer-events: none;

}

.soon {
  position: absolute;
  font: 66.5% admun;
  width: 200px;
  height: 34px;
  top: -9px;
  overflow-y: hidden;
  margin: 2px 0 0 0;
  transform: translateY(0);
  transition: transform 2s ease-in-out;
  animation: soon 1200ms ease-in-out forwards;
  animation-delay: 1s;
  visibility: hidden;
  z-index: -2;
  white-space: nowrap;
}

.orginal-text3 {
  margin-top: 8px;
  float: left;
}

.soon p {
  z-index: 0;
}

.replacement-text3 {
  z-index: -2;
  position: absolute;
  font: 108% admun;
  top: 66%;
  transform: translateY(0);
  text-wrap: nowrap;
  opacity: 0;
  pointer-events: none;

}

.orginal-text3,
.replacement-text3 {
  display: block;
  transition: all 500ms ease-in-out;
}

.cube-movable-3-enter-active {
  animation-fill-mode: forwards;
}

@keyframes movable3 {
  0% {
    visibility: hidden;
    background: black;
    position: absolute;
    top: calc(50% - 10px / 2);
    left: calc(50% - 10px / 2);
  }
  50% {
    visibility: visible;
    position: absolute;
    transition: all 350ms ease;
    top: 49.75%;
    left: 55.7%;
  }
  100% {
    visibility: visible;
    position: absolute;
    transition: all 350ms ease;
    top: 49.75%;
    left: 54.7%;
  }

}

@keyframes soon {


  0% {

    opacity: 1;
    transform: translateX(-70px);
    visibility: visible;


  }

  50% {

    opacity: 1;
    transform: translateX(30px);
    visibility: visible;


  }


  100% {

    opacity: 1;
    transform: translateX(15px);
    visibility: visible;


  }


}

.movable4 {

  visibility: hidden;
  width: 35px;
  height: 35px;
  background: black;
  position: fixed;
  top: calc(50% - 35px / 2);
  left: calc(50% - 35px / 2);
  animation: movable4 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
  z-index: 3;
}

.movable4:hover .divition4 {
  left: 115%;
}


.movable4:hover .design .orginal-text4 {
  /*transition: all 200ms ease-in-out;*/
  transform: translateY(-100%);
  opacity: 0;
}

.movable4:hover .design .replacement-text4 {
  transform: translateY(-100%);
  opacity: 1;
  /*transition: all 200ms ease;*/

}


.movable4:hover {
  background: transparent;
  border: 1px solid black;
  width: 35px;
  height: 35px;
  transition: all 500ms ease;

}

.divition4 {
  background: #ffffff;
  position: absolute;
  width: 190px;
  height: 35px;
  top: 0;
  left: 99%;
  z-index: 2;
  pointer-events: none;

}

.design {
  position: absolute;
  font: 246% admun;
  margin: 2px 0 0 0;
  width: 253px;
  height: 45px;
  top: -5px;
  overflow-y: hidden;
  text-align: end;
  left: -43px;
  transform: translateY(0);
  transition: transform 2s ease-in-out;
  animation: design 1200ms ease-in-out forwards;
  animation-delay: 1s;
  visibility: hidden;
  z-index: -2 !important;
  white-space: nowrap;
}

.orginal-text4 {
  margin-top: 5px;
}

.design p {
  z-index: -2 !important;
}

.replacement-text4 {
  z-index: -2;
  position: absolute;
  font: 104% admun;
  top: 105%;
  left: 59px;
  pointer-events: none;

  transform: translateY(0);
  text-wrap: nowrap;
  opacity: 0;
}

.orginal-text4,
.replacement-text4 {
  display: block;
  transition: all 500ms ease-in-out;
}

.cube-movable-4-enter-active {
  animation-fill-mode: forwards;
}

@keyframes movable4 {
  0% {
    visibility: hidden;
    background: black;
    position: fixed;
    top: calc(50% - 35px / 2);
    left: calc(50% - 35px / 2);
  }
  50% {
    visibility: visible;
    position: fixed;
    transition: all 350ms ease;
    top: calc(59% - 35px / 2);
    left: calc(55% - 35px / 2);
  }
  100% {
    visibility: visible;
    position: fixed;
    transition: all 350ms ease;
    top: calc(58% - 35px / 2);
    left: calc(54% - 35px / 2);
  }

}

@keyframes design {

  0% {

    opacity: 1;
    transform: translateX(10px);
    visibility: visible;


  }

  50% {

    opacity: 1;
    transform: translateX(-235px);
    visibility: visible;


  }

  100% {

    opacity: 1;
    transform: translateX(-220px);
    visibility: visible;


  }


}

.movable5 {

  visibility: hidden;
  width: 30px;
  height: 30px;
  background: black;
  position: fixed;
  top: calc(50% - 30px / 2);
  left: calc(50% - 30px / 2);
  animation: movable5 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
  z-index: 3;
}

.movable5:hover {
  background: transparent;
  border: 1px solid black;
  width: 30px;
  height: 30px;
  transition: all 500ms ease;

}

.movable5:hover .construction .orginal-text5 {
  transform: translateY(-100%);
  opacity: 0;
  /*transition: all 200ms ease;*/

}

.movable5:hover .construction .replacement-text5 {
  transform: translateY(-100%);
  /*transition: all 200ms ease;*/
  opacity: 1;
}


.movable5:hover .divition5 {
  left: -850%;
  display: none;
}

.divition5 {
  background: #ffffff;
  position: absolute;
  width: 250px;
  height: 30px;
  top: 0;
  left: -830%;
  z-index: 2;
  pointer-events: none;

}

.construction {
  position: absolute;
  font: 217% admun;
  height: 44px;
  width: 505px;
  top: -6px;
  left: 8px;
  overflow-y: hidden;
  margin: 1px 0 0 0;
  transform: translateY(0);
  animation: construction 1200ms ease-in-out forwards;
  animation-delay: 1s;
  visibility: hidden;
  z-index: -4;
  white-space: nowrap;
}

.orginal-text5 {
  margin-top: 6px;
  float: left;
}

.construction p {
  z-index: 0;
}

.replacement-text5 {
  z-index: -2;
  position: absolute;
  font: 104% admun;
  top: 99%;
  /*left: 5%;*/
  transform: translateX(0);
  text-wrap: nowrap;
  pointer-events: none;

  opacity: 0;
}

.orginal-text5,
.replacement-text5 {
  display: block;
  transition: all 500ms ease-in-out;
}

.cube-movable-5-enter-active {
  animation-fill-mode: forwards;
}

@keyframes movable5 {
  0% {
    visibility: hidden;
    background: black;
    position: absolute;
    top: calc(50% - 30px / 2);
    left: calc(50% - 30px / 2);
  }
  50% {
    visibility: visible;
    position: absolute;
    transition: all 350ms ease;
    top: calc(72.8% - 30px / 2);
    left: calc(37.8% - 30px / 2);
  }
  100% {
    visibility: visible;
    position: absolute;
    transition: all 350ms ease;
    top: calc(71.8% - 30px / 2);
    left: calc(38.8% - 30px / 2);
  }

}

@keyframes construction {

  0% {

    opacity: 1;
    transform: translateX(-250px);
    visibility: visible;


  }

  50% {

    opacity: 1;
    transform: translateX(45px);
    visibility: visible;


  }

  100% {

    opacity: 1;
    transform: translateX(30px);
    visibility: visible;


  }


}

.mt-2 {
  margin-top: 2px;
}

.circle-replace {
  position: absolute;
  width: 20px;
  height: 20px;
  background: black;
  border-radius: 50%;
  left: 89.9%;
  top: 0;
  opacity: 0;
  animation: circle 1000ms ease-in forwards;
  z-index: 5;

}

.circle {
  position: absolute;
  width: 20px;
  height: 20px;
  background: black;
  border-radius: 50%;
  left: 89.9%;
  top: 0;
  opacity: 0;
  animation: circle 1000ms ease-in forwards;
  z-index: 2;


}


.circle-move-enter-active {
  animation-fill-mode: forwards;
}


@keyframes circle {
  0% {
    left: 89.9%;
    top: 0;
    opacity: 0;
  }
  100% {
    left: 89.9%;
    top: 8.8%;
    opacity: 1;
  }
}

.circle1 {
  position: absolute;
  left: 0;
  top: 8.8%;
  background: white;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  opacity: 0;
  animation: circle1 1000ms ease forwards 500ms !important;
  z-index: 0;


}

.circle2 {
  position: absolute;
  left: 0;
  top: 8.8%;
  background: white;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  opacity: 0;
  animation: circle2 1000ms ease forwards 500ms !important;
  z-index: 0;
}

.circle3 {
  position: absolute;
  left: 0;
  top: 8.8%;
  background: white;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  opacity: 0;
  animation: circle3 1000ms ease forwards 500ms !important;
  z-index: 0;

}


.circle-move-enter-active {
  animation: circle1 0.5s;
}


.circle-move-leave-active {
  animation: circle1 1s reverse;


}

.circle-move-leave-active .circle1 {
  transform: translateY(-35px);
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  opacity: 0;
}

.circle-move-leave-active .circle2 {

  transform: translateY(-65px);
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  opacity: 0;

}

.circle-move-leave-active .circle3 {
  transform: translateY(-95px);
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  opacity: 0;

}

@keyframes circle1 {
  0% {
    left: 0;
    top: 8.8%;
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    left: 0;
    top: 35px;

    opacity: 1;
  }
}

@keyframes circle2 {
  0% {
    left: 0;
    top: 8.8%;
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    left: 0;
    top: 65px;
    opacity: 1;
  }
}

@keyframes circle3 {
  0% {
    left: 0;
    top: 8.8%;
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    left: 0;
    top: 95px;

    opacity: 1;
  }
}


@media (max-width: 1025px) and (max-height: 1366px) {


  .show-mobile {
    display: inline-block;
  }

  .hide-mobile {
    display: none;
  }


  .construction {
    font: 168% admun;

    top: -0.3px;

  }

  .design {
    font: 220% admun;

    top: -3px;

  }

}
@media (max-width: 1370px) and (max-height: 920px) {
  .show-mobile {
    display: inline-block;
  }

  .hide-mobile {
    display: none;
  }
}

@media (max-width: 960px) {

  .show-mobile {
    display: inline-block;
  }

  .hide-mobile {
    display: none;
  }

  .witheBox2 {
    display: none;
  }

  .witheBox3 {
    display: inline-block;
  }

  .move {
    width: 100%;
    height: 100%;
  }

  .construction {
    font: 158.688% admun;
    top: -6px;
  }

  .design {
    font: 222% admun;
    top: -2px;
  }

  .orginal-text5 {
    margin-top: 8px;

  }


  .about {
    font: 239% admun;
    top: -5px;
  }

  .awards {
    font: 131% admun;
    top: -6px;
  }

  .movable5 {
    width: 25px;
    height: 25px;
  }

  .movable5:hover .divition5 {
    left: -850%;
  }


  .divition5 {
    background: #ffffff;
    position: absolute;
    width: 253px;
    height: 25px;
    top: 0;
    left: -1009%;
    z-index: 2;
  }

  .movable1 {

    visibility: hidden;
    width: 35px;
    height: 35px;
    background: black;
    position: absolute;
    top: calc(50% - 35px / 2);
    left: calc(50% - 35px / 2);
    animation: movable1 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
    z-index: 3;

  }

  .movable2 {
    z-index: 3;
    animation: movable2 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
  }

  @keyframes movable1 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 35px / 2);
      left: calc(50% - 35px / 2);
    }

    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(33.65% - 35px / 2);
      left: calc(37.8% - 35px / 2);
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(34.65% - 35px / 2);
      left: calc(38.8% - 35px / 2);
    }

  }
  @keyframes movable2 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 20px / 2);
      left: calc(50% - 20px / 2);
    }
    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;

      top: calc(42.8% - 20px / 2);
      left: calc(44.2% - 20px / 2);
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(43.8% - 20px / 2);
      left: calc(45.2% - 20px / 2);

    }
  }


  @keyframes movable3 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 10px / 2);
      left: calc(50% - 10px / 2);
    }
    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: 49.75%;
      left: 61.7%;
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: 49.75%;
      left: 60.7%;
    }

  }



  @keyframes movable4 {
    0% {
      visibility: hidden;
      background: black;
      position: fixed;
      top: calc(50% - 35px / 2);
      left: calc(50% - 35px / 2);
    }
    50% {
      visibility: visible;
      position: fixed;
      transition: all 350ms ease;
      top: calc(61% - 35px / 2);
      left: calc(63% - 35px / 2);
    }
    100% {
      visibility: visible;
      position: fixed;
      transition: all 350ms ease;
      top: calc(60% - 35px / 2);
      left: calc(62% - 35px / 2);
    }

  }

  @keyframes movable5 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 30px / 2);
      left: calc(50% - 30px / 2);
    }
    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(72.8% - 30px / 2);
      left: calc(8.8% - 30px / 2);
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(71.8% - 30px / 2);
      left: calc(9.8% - 30px / 2);
    }

  }



  .movable1:hover .about .orginal-text1 {
    transform: none;
    opacity: unset;
  }

  .replacement-text1 {
    display: none;
  }

  .movable1:hover {
    background: black;
    border: unset;
    width: 35px;
    height: 35px;
    transition: none;
  }

  .movable2:hover .awards .orginal-text2 {
    transform: none;
    opacity: unset;
  }

  .replacement-text2 {
    display: none;
  }

  .movable2:hover {
    background: black;
    border: unset;
    width: 20px;
    height: 20px;
    transition: none;
  }


  .movable3:hover .soon .orginal-text3 {
    transform: none;
    opacity: unset;
  }

  .replacement-text3 {
    display: none;
  }

  .movable3:hover {
    background: black;
    border: unset;
    width: 10px;
    height: 10px;
    transition: none;
  }


  .movable4:hover .design .orginal-text4 {
    transform: none;
    opacity: unset;
  }

  .replacement-text4 {
    display: none;
  }

  .movable4:hover {
    background: black;
    border: unset;
    width: 35px;
    height: 35px;
    transition: none;
  }


  .movable5:hover .construction .orginal-text5 {
    transform: none;
    opacity: unset;
  }

  .replacement-text5 {
    display: none;
  }

  .movable5:hover {
    background: black;
    border: unset;
    width: 25px;
    height: 25px;
    transition: none;
  }


}


@media (min-height: 200px) and (max-height: 500px) and (max-width: 960px) {

  .orginal-text5 {
    margin-top: 10px;
  }
  .construction {
    position: absolute;

    height: 44px;
    width: 505px;
    top: -8px;
    left: 8px;

  }
  .movable4 {

    visibility: hidden;
    width: 35px;
    height: 35px;
    background: black;
    position: fixed;
    top: calc(50% - 35px / 2);
    left: calc(50% - 35px / 2);
    animation: movable4 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
    z-index: 3;
  }

  .movable5 {

    visibility: hidden;
    width: 25px;
    height: 25px;
    background: black;
    position: fixed;
    top: calc(50% - 30px / 2);
    left: calc(50% - 30px / 2);
    animation: movable5 800ms cubic-bezier(0.4, 0, 1, 1) forwards !important;
    z-index: 3;
  }

  .movable1:hover .about .orginal-text1 {
    transform: none;
    opacity: unset;
  }

  .replacement-text1 {
    display: none;
  }

  .movable1:hover {
    background: black;
    border: unset;
    width: 35px;
    height: 35px;
    transition: none;
  }

  .movable2:hover .awards .orginal-text2 {
    transform: none;
    opacity: unset;
  }

  .replacement-text2 {
    display: none;
  }

  .movable2:hover {
    background: black;
    border: unset;
    width: 20px;
    height: 20px;
    transition: none;
  }


  .movable3:hover .soon .orginal-text3 {
    transform: none;
    opacity: unset;
  }

  .replacement-text3 {
    display: none;
  }

  .movable3:hover {
    background: black;
    border: unset;
    width: 10px;
    height: 10px;
    transition: none;
  }


  .movable4:hover .design .orginal-text4 {
    transform: none;
    opacity: unset;
  }

  .replacement-text4 {
    display: none;
  }

  .movable4:hover {
    background: black;
    border: unset;
    width: 35px;
    height: 35px;
    transition: none;
  }

  .movable5:hover .construction .orginal-text5 {
    transform: none;
    opacity: unset;
  }

  .replacement-text5 {
    display: none;
  }


  .movable5:hover {
    background: black;
    border: unset;
    width: 25px;
    height: 25px;
    transition: none;
  }


  @keyframes movable1 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 35px / 2);
      left: calc(50% - 35px / 2);
    }

    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(29.65% - 35px / 2);
      left: calc(37.8% - 35px / 2);
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(30.65% - 35px / 2);
      left: calc(38.8% - 35px / 2);
    }

  }
  @keyframes movable2 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 20px / 2);
      left: calc(50% - 20px / 2);
    }
    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;

      top: calc(40.8% - 20px / 2);
      left: calc(44.2% - 20px / 2);
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(41.8% - 20px / 2);
      left: calc(45.2% - 20px / 2);

    }
  }


  @keyframes movable3 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 10px / 2);
      left: calc(50% - 10px / 2);
    }
    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: 49.75%;
      left: 61.7%;
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: 49.75%;
      left: 60.7%;
    }

  }



  @keyframes movable4 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 35px / 2);
      left: calc(50% - 35px / 2);
    }
    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(66% - 35px / 2);
      left: calc(63% - 35px / 2);
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      color: black;
      top: calc(65% - 35px / 2);
      left: calc(62% - 35px / 2);
    }

  }

  @keyframes movable5 {
    0% {
      visibility: hidden;
      background: black;
      position: absolute;
      top: calc(50% - 30px / 2);
      left: calc(50% - 30px / 2);
    }
    50% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(78.8% - 30px / 2);
      left: calc(25.8% - 30px / 2);
    }
    100% {
      visibility: visible;
      position: absolute;
      transition: all 350ms ease;
      top: calc(77.8% - 30px / 2);
      left: calc(26.8% - 30px / 2);
    }

  }

}


</style>
